module.exports = __webpack_public_path__ + "img/fondo__login.49086c95.svg";